<template>
  <v-layout>
    <v-flex xs12 md12>
      <div>
        <v-data-table
          :items="lastestRateItems"
          hide-actions
          class="elevation-1"
        >
          <template slot="headers" slot-scope="props">
            <tr class="alpha">
              <th>
                ประเภท
              </th>
              <th colspan="14">
                แบบที่ 1 แยก L และ G
              </th>
              <th colspan="14">
                แบบที่ 2 
              </th>
            </tr>

            <tr class="bravo">
              <th>
                ลักษณะการสอน
              </th>
              <th colspan=10>
                L บรรยาย
              </th>
              <th colspan="4">
                G กลุ่ม
              </th>
              <th colspan="4">
                L&G
              </th>
              <th colspan="4">
                L บรรยาย
              </th>
              <th colspan="4">
                G กลุ่ม
              </th>
            </tr> 

            <tr class="charlie">
              <th>
                หลักสูตร
              </th>
              <th colspan="4">
                ปกติ
              </th>
              <th colspan="4">
                นานาชาติ
              </th>
              <th colspan="1">
                บางขุนเทียน
              </th>
              <th colspan="1">
                ราชบุรี
              </th>
              <th colspan="1">
                ปกติ
              </th>
              <th colspan="1">
                นานาชาติ
              </th>
              <th colspan="1">
                บางขุนเทียน
              </th>
              <th colspan="1">
                ราชบุรี
              </th>
              <th colspan="1">
                ปกติ
              </th>
              <th colspan="1">
                นานาชาติ
              </th>
              <th colspan="1">
                บางขุนเทียน
              </th>
              <th colspan="1">
                ราชบุรี
              </th>
              <th colspan="1">
                ปกติ
              </th>
              <th colspan="1">
                นานาชาติ
              </th>
              <th colspan="1">
                บางขุนเทียน
              </th>
              <th colspan="1">
                ราชบุรี
              </th>
              <th colspan="1">
                ปกติ
              </th>
              <th colspan="1">
                นานาชาติ
              </th>
              <th colspan="1">
                บางขุนเทียน
              </th>
              <th colspan="1">
                ราชบุรี
              </th>
            </tr> 

          
            <tr class="delta">
              <th>
               จำนวน น.ศ.
              </th>
              <th>
                <200
              </th>
              <th>
                201-400
              </th>
              <th>
                401 ขึ้นไป
              </th>
              <th>
                เหมา
              </th>
              <th>
                <200
              </th>
              <th>
                201-400
              </th>
              <th>
                401 ขึ้นไป
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
              <th>
                เหมา
              </th>
            </tr> 
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.personType.name }}</td>
            <td class="text-xs-center">{{ props.item.ln1 }}</td>
            <td class="text-xs-center">{{ props.item.ln2 }}</td>
            <td class="text-xs-center">{{ props.item.ln3 }}</td>
            <td class="text-xs-center">{{ props.item.ln4 }}</td>

            <td class="text-xs-center">{{ props.item.li1 }}</td>
            <td class="text-xs-center">{{ props.item.li2 }}</td>
            <td class="text-xs-center">{{ props.item.li3 }}</td>
            <td class="text-xs-center">{{ props.item.li4 }}</td>

            <td class="text-xs-center">{{ props.item.la }}</td>
            <td class="text-xs-center">{{ props.item.lr }}</td>

            <td class="text-xs-center">{{ props.item.gn }}</td>
            <td class="text-xs-center">{{ props.item.gi }}</td>
            <td class="text-xs-center">{{ props.item.ga }}</td>
            <td class="text-xs-center">{{ props.item.gr }}</td>

            <td class="text-xs-center">{{ props.item.cn }}</td>
            <td class="text-xs-center">{{ props.item.ci }}</td>
            <td class="text-xs-center">{{ props.item.ca }}</td>
            <td class="text-xs-center">{{ props.item.cr }}</td>

            <td class="text-xs-center">{{ props.item.cln }}</td>
            <td class="text-xs-center">{{ props.item.cli }}</td>
            <td class="text-xs-center">{{ props.item.cla }}</td>
            <td class="text-xs-center">{{ props.item.clr }}</td>

            <td class="text-xs-center">{{ props.item.cgn }}</td>
            <td class="text-xs-center">{{ props.item.cgi }}</td>
            <td class="text-xs-center">{{ props.item.cga }}</td>
            <td class="text-xs-center">{{ props.item.cgr }}</td>
          </template>
        </v-data-table>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  props: ['lastestRateItems'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
  .alpha>* {
    color: #757575 !important;
    text-shadow: 1px 1px white;
    font-weight: 700;
    font-size: 14px;
    border:  2px solid white;
    background-color: #E0E0E0;
  }
  .bravo>* {
    color: #757575 !important;
    text-shadow: 1px 1px white;
    font-weight: 700;
    font-size: 14px;
    border:  2px solid white;
    background-color: #E0E0E0;
  }
  .charlie>* {
    color: #757575 !important;
    text-shadow: 1px 1px white;
    font-weight: 700;
    font-size: 14px;
    border:  2px solid white;
    background-color: #E0E0E0;
  }
  .delta>* {
    color: #757575 !important;
    text-shadow: 1px 1px white;
    font-weight: 700;
    font-size: 14px;
    border:  2px solid white;
    background-color: #E0E0E0;
  }
</style>


// WEBPACK FOOTER //
// src/components/settings/wageRate/lastestRates.vue